<template>
	<li class="item">
        <!-- 当不能预约的时候加上类  disabled -->
        <div  class="izk-course-info">
            <!-- 角标 hot -->
            <span class="ico-course-hot ti" v-if="course.is_hot">hot</span>
            <!-- 角标 new -->
            <!--<span class="ico-course-new ti">new</span>-->
            <router-link class="info-con" :to="detailLink">
                <h4 class="title te2">
                    <i class="tag">{{course.subject_msg && course.subject_msg.substring(0, 1)}}</i>{{course.title}}
                </h4>
                <p class="info"><i class="ico-course-time">{{course.course_begin_datetime}}-{{course.course_end_datetime}}</i></p>
                <p class="info"><i class="ico-course-place">{{course.school_info && course.school_info.name}}</i></p>
            </router-link>
            <div class="reserve cbox">
                <div class="flex">
                    <span class="times">{{course.totalNum}}次课</span>
                    <span class="num">{{course.buyNum}}人已预约</span>
                    <!-- <span class="num">{{course.remaining_quotas}}</span> -->
                    <!-- <span class="heat">{{course.remaining_quotas}}</span> -->
                </div>
                <a href="javascript:void(0)" class="g-btn3" @click="order">立即预约</a>
            </div>
        </div>
    </li>
</template>
<script>
    import {mapState} from 'vuex';
    import {getStore} from '../../../../common/libs/common.js';
    import vue from 'vue';

export default{
  name: 'OneCommon',
  props: {
    course: {
          type: Object,
          default: {},
          required: true
    }
  },
  data(){
    return {

    }
  },
      computed: {
        detailLink(){
          let course = this.course;
          let route = this.$route;

          return {
            path: `/${  route.params.city  }/detail/${  course.course_id}`,
            query: {
              course_id: course.courseId,
              grade: course.grade,
              type: course.type,
              sub_type: course.sub_type,
              school_id: course.school_id,
              lat: this.$store.state.home.location.lat || '',
              lng: this.$store.state.home.location.lng || '',
              category: "10001",
              course_type: 102,
              routeName: 'faceToface'
            }
          }
        }
      },
  methods: {
        order(){
          this.$emit('order', this.course);
        }
  },
  created(){

  },
      mounted(){

      }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/one/public/Common.vue